
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BASE_URL } from "../services/configUrls";
import { useTheme } from "@mui/material/styles";
export default function LoginExpirePopup() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    const shownPerLogin = sessionStorage.getItem("loginExpirePopupShown");

    if (!shownPerLogin) {
      (async () => {
        try {
          const res = await axios.get(
            `${BASE_URL}/accounts/renewal-popup/status`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
            }
          );

          const shouldOpen =
            res.data?.membership?.show_popup_login ||
            res.data?.student_addition?.show_popup_addition ||
            res.data?.existing_enrollment?.show_popup_enrollment;

          if (shouldOpen) {
            setData(res.data);
            setOpen(true);
            sessionStorage.setItem("loginExpirePopupShown", "true");
          }
        } catch (err) {
          console.error(
            "Failed to fetch renewal status:",
            err.response || err.message
          );
        }
      })();
    }
  }, []);

  if (!data) return null;

  return (
    <Dialog
  open={open}
  fullWidth
  maxWidth={false}
  PaperProps={{
    sx: {
      width: "720px",
      borderRadius: 3,
      p: 3,
      boxShadow: 10,
      backgroundColor: "#ffffff",

      /* 👇 FIX */
      userSelect: "none",
      cursor: "default",
    },
  }}
>

      {/* HEADER */}
   <DialogTitle sx={{ p: 0 }}>
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
  >
    <Box>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ color: "#000" }}
      >
        Membership Status
      </Typography>

      <Box mt={1}>
        <Chip
          label={`Membership Expires on ${data.expiry}`}
          size="small"
          sx={{
            backgroundColor: "#fff4e5", 
            color: "#e65100",
            fontWeight: 600,
            borderRadius: "9px",
          }}
        />
      </Box>
    </Box>

   
    <IconButton onClick={() => setOpen(false)} sx={{ cursor: "pointer" }}>
  <CloseIcon sx={{ color: "#000" }} />
</IconButton>
  </Box>
</DialogTitle>



      <Divider
  sx={{
    my: 2,
    borderColor: "#e0e0e0", // light gray, visible on white
  }}
/>

      {/* BODY */}
      <DialogContent sx={{ p: 0 }}>
        {/* LOGIN ACCESS */}
        {data?.membership?.show_popup_login && (
          <Box mb={2} p={2} borderRadius={2} bgcolor="#fff3e0">
            <Typography fontWeight="bold" color="#e65100">
              🔐 Login Access
            </Typography>

            <Typography mt={1} fontWeight="bold" color="#c62828">
              ❌ Your login access will be closed by{" "}
              {data.membership.login_block_from}.
            </Typography>
          </Box>
        )}

        {/* STUDENT ONBOARDING */}
        {data?.student_addition?.show_popup_addition && (
          <Box mb={2} p={2} borderRadius={2} bgcolor="#e3f2fd">
            <Typography fontWeight="bold" color="#0d47a1">
              👥 Student Onboarding
            </Typography>

            <Typography mt={1} fontWeight="bold" color="#1565c0">
              ❌ Your student onboarding will be closed on{" "}
              {data.student_addition.block_from}.
            </Typography>
          </Box>
        )}

        {/* EXISTING STUDENT ENROLLMENT */}
        {data?.existing_enrollment?.show_popup_enrollment && (
          <Box mb={2} p={2} borderRadius={2} bgcolor="#fce4ec">
            <Typography fontWeight="bold" color="#880e4f">
              📘 Existing Student Internship Enrollment
            </Typography>

            <Typography mt={1} fontWeight="bold" color="#ad1457">
              ❌ Your students will not be able to apply for internship in Cohort{" "}
              {data.existing_enrollment.cohort_id}.
            </Typography>
          </Box>
        )}

        {/* COMMON RENEWAL INFO */}
        <Divider
  sx={{
    my: 2,
    borderColor: "#e0e0e0", // light gray, visible on white
  }}
/>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
            px: 2,
            py: 1.5,
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
            border: "1px dashed #dcdcdc",
          }}
        >
          <Typography fontSize="0.9rem" color="#444">
            To renew your membership, please contact
          </Typography>

          <Typography fontSize="0.9rem">
            <a
  href="mailto:membership@eduskillsfoundation.org"
  style={{
    fontWeight: 600,
    color: "#1976d2",
    textDecoration: "none",
    cursor: "pointer",
  }}
>

              membership@eduskillsfoundation.org
            </a>
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
